"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _markdown = _interopRequireDefault(require("../markdown"));

var _sections = require("./sections");

require("./quote.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @param {Object} props
 * @param {String} props.className
 * @param {String} props.quote Markdown
 * @param {Object} props.person Contentful fields
 */
var Quote = function Quote(_ref) {
  var className = _ref.className,
      quote = _ref.quote,
      person = _ref.person;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Quote ".concat(className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "person"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: _lodash["default"].get(person, 'fields.photo[0].fields.file.url'),
    alt: _lodash["default"].get(person, 'fields.name')
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "quoteText"
  }, /*#__PURE__*/_react["default"].createElement(_markdown["default"], {
    source: "".concat(quote)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "name"
  }, "\xA0 \u2014 \xA0", "".concat(_lodash["default"].get(person, 'fields.name'), ", ").concat(_lodash["default"].get(person, 'fields.title')))));
};

Quote.propTypes = {
  person: _propTypes["default"].object.isRequired,
  // eslint-disable-line
  quote: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string
};
Quote.defaultProps = {
  className: ''
};
(0, _sections.registerWidget)('quote', Quote);
var _default = Quote;
exports["default"] = _default;